import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  to?: string;
  linkText?: string;
  accent?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, to, linkText = '查看全部', accent }: SectionHeadingProps) {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className={`mb-2 flex items-center gap-2 text-sm font-bold tracking-wide ${accent ? 'text-accent-600' : 'text-primary-600'}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${accent ? 'bg-accent-500' : 'bg-primary-500'}`}></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {to && (
        <Link
          to={to}
          onClick={scrollTop}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {linkText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}